export default __webpack_public_path__ + "region.svg";